var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"searchNodeTypes"}},[_c('label',{staticClass:"position-relative d-block"},[_c('i',{staticClass:"fas fa-search position-absolute h-100 text-muted ml-2"}),_c('b-input',{attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }